import { render, staticRenderFns } from "./ShareList.vue?vue&type=template&id=5331ea92&scoped=true&"
import script from "./ShareList.vue?vue&type=script&lang=js&"
export * from "./ShareList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331ea92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5331ea92')) {
      api.createRecord('5331ea92', component.options)
    } else {
      api.reload('5331ea92', component.options)
    }
    module.hot.accept("./ShareList.vue?vue&type=template&id=5331ea92&scoped=true&", function () {
      api.rerender('5331ea92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/list/ShareList.vue"
export default component.exports